import tippy from "tippy.js";
tippy("[data-tippy-content]", {
	// hideOnClick: false, //for debugging
	// trigger: 'click', //for debugging
});
